import { render, staticRenderFns } from "./AudiosSection.vue?vue&type=template&id=6aa97116&"
import script from "./AudiosSection.vue?vue&type=script&lang=js&"
export * from "./AudiosSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports